import { Pipe, PipeTransform } from '@angular/core';

import { Fai, ProductFactory, Subscription } from '@bytel/bytel-sales';
import { CommercialSeries } from '@bytel/checkout';

@Pipe({
    name: 'isSmartTV',
    standalone: true,
})
export class SmartTVPipe implements PipeTransform {
    transform(plan: Subscription): boolean {
        if (plan && ProductFactory.Is(plan, Fai)) {
            return plan.data.commercial_series === CommercialSeries.SMART_TV;
        } else {
            return false;
        }
    }
}
